module.exports = __webpack_public_path__ + "img/ins_step2_success.bb2fa5ca.svg";